/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum GuideType {
    GRID_GUIDE,
    ONE_LINE_GUIDE,
    FILTERED_GUIDE
}
